import { Controller } from '@hotwired/stimulus'
import { Tab } from 'bootstrap'

export default class extends Controller {
  static targets = ['tab']

  connect() {
    this.activateTabFromHash()
  }

  switch(event) {
    event.preventDefault()

    // Access the tab trigger through Stimulus target instead of querySelector
    // This avoids Bootstrap's "Illegal invocation" error by explicitly referencing
    // the tab element from outside the turbo frame context
    if (this.hasTabTarget) {
      const tab = Tab.getOrCreateInstance(this.tabTarget)
      tab.show()
    }
  }

  activateTabFromHash() {
    const hash = window.location.hash

    if (hash) {
      const tabTrigger = this.element.querySelector(`[data-bs-target="${hash}"]`)

      if (tabTrigger) {
        const tab = Tab.getOrCreateInstance(tabTrigger)
        tab.show()
      }
    }
  }
}
